import {
  Tooltip as HeroTooltip,
  type TooltipProps as HeroTooltipProps,
} from "@heroui/react";

export type TooltipProps = HeroTooltipProps;

export function Tooltip(props: TooltipProps) {
  return <HeroTooltip {...props} />;
}

Tooltip.displayName = "RecareUI.Tooltip";
